export default "__VITE_ASSET__Y$MeV2TQ__"